// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"64eb3f5e","453":"5b64ae55"}[chunkId] + ".chunk.js";
};